
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 10 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.682 15.864l.711-.687c.143-.18.143-.47 0-.614L2.955 7.982l6.438-6.545c.143-.144.143-.434 0-.614L8.682.136a.405.405 0 00-.605 0L.607 7.693a.496.496 0 000 .614l7.47 7.557c.178.181.427.181.605 0z","fill":"currentColor"}})])
          )
        }
      }
    